function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_4738",
  width: 16.05,
  height: 16.05,
  rx: 8.025,
  fill: "#0077b5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_28281",
  d: "M20.439,18.925q-.783-.019-1.567,0c-.113,0-.138-.025-.138-.138v-2.8a2.1,2.1,0,0,0-.075-.627.911.911,0,0,0-1.48-.451,1.087,1.087,0,0,0-.4.915v2.633a3.276,3.276,0,0,0,0,.351c.013.1-.038.125-.125.113h-1.6c-.1,0-.125-.025-.125-.125.013-.79.013-1.58.013-2.382,0-.978,0-1.956-.013-2.922,0-.113.025-.138.125-.138h1.6c.1,0,.125.025.125.125v.639l.063-.063a1.87,1.87,0,0,1,1.994-.79,1.978,1.978,0,0,1,1.693,1.806,4.567,4.567,0,0,1,.05.715v3C20.577,18.887,20.552,18.925,20.439,18.925Zm-6.52-2.784v2.633c0,.113-.025.15-.138.15-.527-.013-1.053,0-1.58,0-.1,0-.125-.025-.125-.125V13.483c0-.088.025-.125.125-.125h1.618c.113,0,.125.038.125.138-.025.877-.025,1.755-.025,2.645Zm.088-4.238a1.019,1.019,0,0,1-1.229.69A.96.96,0,0,1,13,10.687.96.96,0,0,1,14.007,11.9Z",
  transform: "translate(-7.959 -7.113)",
  fill: "#fff"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.05,
    height: 16.05,
    viewBox: "0 0 16.05 16.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4cff9c81.svg";
export { ForwardRef as ReactComponent };